module.exports = __webpack_public_path__ + "img/1-7.e3ef8a1f.png";